export default __webpack_public_path__ + "static/small-image-sportplus-4-1521ea05bf53531e4aac3356e26c9fc8.png";